import { render, staticRenderFns } from "./OrderFromCatalogPartner.vue?vue&type=template&id=72697712&scoped=true&"
import script from "./OrderFromCatalogPartner.vue?vue&type=script&lang=js&"
export * from "./OrderFromCatalogPartner.vue?vue&type=script&lang=js&"
import style0 from "./OrderFromCatalogPartner.vue?vue&type=style&index=0&id=72697712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72697712",
  null
  
)

export default component.exports